import NextLink from 'next/link';

import { selectPathProgressByPathId } from 'features/pathProgresses/slice';
import { useSelector } from 'react-redux';

import {
  Card,
  Difficulty,
  Heading,
  Image,
  tailwindPreset,
  ProgressBar,
} from '@frontendmentorio/design-system-v2';

const { theme } = tailwindPreset;

export default function LearningPathCard({ path }) {
  const progress = useSelector((state) =>
    selectPathProgressByPathId(state, path.id)
  );

  return (
    <Card
      className="flex flex-col-reverse gap-6 p-5 tablet:flex-row tablet:items-stretch"
      tagName="li"
    >
      <div className="flex flex-col gap-4 items-start tablet:justify-center">
        <Difficulty level={path.difficulty} />

        <NextLink
          className="hover:underline"
          href={`/learning-paths/${path.slug}`}
        >
          <Heading level="4" tagName="h2">
            {path.title}
          </Heading>
        </NextLink>

        <p className="text-neutral-500">{path.description}</p>

        {progress && (
          <ProgressBar isLabelVisible progress={progress.completedRatio} />
        )}
      </div>

      <NextLink
        aria-hidden="true"
        className="block relative min-h-[15rem] min-w-[40%] w-full"
        href={`/learning-paths/${path.slug}`}
        tabIndex="-1"
      >
        <Image
          alt=""
          className="object-cover rounded-xl"
          fill={true}
          sizes={`(min-width: ${theme.screens.tablet}) 33vw, 100vw`}
          src={path.image}
        />
      </NextLink>
    </Card>
  );
}
